import "./ServiceSpectrum.css";
import { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { openBooking } from "../../utils/booking";
import { packages } from "./packages";
gsap.registerPlugin(useGSAP);

function PackageCard({ pkg, index }) {
  return (
    <article className="spectrum-card">
      <div className="spectrum-art" style={{ backgroundImage: `url(${pkg.art})` }}>
        <span className="label spectrum-art-number">[0{index + 1}]</span>
        <p className="spectrum-art-title">{pkg.title}</p>
      </div>

      <div className="stack stack--tight">
        <p className="label package-meta">{pkg.timeline}</p>
        <h3 className="h3">{pkg.title}</h3>
        <p className="text">{pkg.line}</p>
      </div>

      <div className="stack stack--tight">
        <span className="label">Deliverables</span>
        <ul className="list list--squares">
          {pkg.deliverables.map((item) => <li key={item}>{item}</li>)}
        </ul>
      </div>

      <div className="spectrum-actions">
        <button type="button" className="btn" onClick={() => openBooking(pkg.title)}>
          Book a call
        </button>
      </div>
    </article>
  );
}

function ServiceSpectrum() {
  const containerRef = useRef(null);
  const titleRef = useRef(null);

  useGSAP(() => {
    const grid = containerRef.current.querySelector(".card-grid");

    gsap.matchMedia().add(
      { isDesktop: "(min-width: 900px)", isMobile: "(max-width: 899px)" },
      ({ conditions: { isMobile } }) => {
        gsap.fromTo(
          grid,
          { y: isMobile ? 50 : 100, scale: isMobile ? 0.95 : 0.9, filter: "blur(20px)", autoAlpha: 0 },
          {
            scrollTrigger: {
              trigger: containerRef.current,
              start: isMobile ? "top 85%" : "top 100%",
              end: "top 50%",
              scrub: 1,
            },
            y: 0,
            scale: 1,
            filter: "blur(0px)",
            autoAlpha: 1,
            ease: "none",
          }
        );
      }
    );

    // Parallax title: scrolls slower and blurs when overlapped
    gsap.to(titleRef.current, {
      scrollTrigger: { trigger: containerRef.current, start: "top 50%", end: "top -20%", scrub: true },
      y: 150,
      filter: "blur(20px)",
      opacity: 0,
      ease: "none",
    });
  }, { scope: containerRef });

  return (
    <div className="section spectrum" ref={containerRef}>
      <h2 className="section-title" ref={titleRef}>Packages</h2>
      <div className="card-grid">
        {packages.map((pkg, index) => (
          <PackageCard key={pkg.title} pkg={pkg} index={index} />
        ))}
      </div>
    </div>
  );
}

export default ServiceSpectrum;
